module.exports = __webpack_public_path__ + "statics/img/f2741b1.f2741b13.png";